import { render, staticRenderFns } from "./PromoEdit.vue?vue&type=template&id=22fe65d3&scoped=true&lang=pug&"
import script from "./PromoEdit.vue?vue&type=script&lang=js&"
export * from "./PromoEdit.vue?vue&type=script&lang=js&"
import style0 from "./PromoEdit.vue?vue&type=style&index=0&id=22fe65d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fe65d3",
  null
  
)

export default component.exports